import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/i18n/translations";

const LanguageContext = createContext(undefined);

const detectLang = () => {
  if (typeof window === "undefined") return "en";
  const stored = window.localStorage.getItem("luki-lang");
  if (stored === "tr" || stored === "en") return stored;
  const nav = (navigator.language || navigator.userLanguage || "en").toLowerCase();
  return nav.startsWith("tr") ? "tr" : "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(detectLang);

  useEffect(() => {
    window.localStorage.setItem("luki-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggle = () => setLang((p) => (p === "tr" ? "en" : "tr"));
  const t = translations[lang];

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
